var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadCloud(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1949_23742)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.6663 10.6667L7.99967 8L5.33301 10.6667",
    stroke: "#5570F1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 8V14",
    stroke: "#5570F1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5933 12.2601C14.2435 11.9056 14.7572 11.3447 15.0532 10.6658C15.3493 9.98698 15.4108 9.22889 15.2281 8.5112C15.0454 7.7935 14.629 7.15708 14.0444 6.70237C13.4599 6.24766 12.7406 6.00056 12 6.00007H11.16C10.9582 5.21956 10.5821 4.49496 10.0599 3.88073C9.5378 3.2665 8.8832 2.77864 8.14537 2.45381C7.40754 2.12898 6.60567 1.97564 5.80005 2.00533C4.99443 2.03501 4.20602 2.24694 3.49409 2.62518C2.78216 3.00342 2.16525 3.53814 1.68972 4.18913C1.2142 4.84011 0.892434 5.59043 0.748627 6.38367C0.60482 7.17691 0.64271 7.99242 0.859449 8.76891C1.07619 9.5454 1.46613 10.2626 1.99997 10.8667",
    stroke: "#5570F1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6663 10.6667L7.99967 8L5.33301 10.6667",
    stroke: "#5570F1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1949_23742"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadCloud);
export default __webpack_public_path__ + "static/media/upload-cloud.d6876f0aa40608e2a1c7f04f41ad794d.svg";
export { ForwardRef as ReactComponent };